import { optionsRequest } from '@dynameat/api';
import * as MutationTypes from '@dynameat/mutationTypes';

export const optionListRequest = async ({ commit, getters: { options } }) => {
  if (options.length === 0) {
    const response = await optionsRequest();
    const optionList = response.data.results;
    commit(MutationTypes.OPTIONS_SUCCESS, optionList);
    return optionList;
  }
  return options;
};
